export default {
  DASHBOARD: 'Dashboard',
  BUILD_OPTIONS: 'Build Options',
  MANUALS: 'Manuals',
  SCHEMATICS: 'Schematics',
  WARRANTY: 'Warranty',
  LOCATION_HISTORY: 'Location History',
  MAINTENANCE_SCHEDULE: 'Maintenance Schedule',
  FAULT_CODES: 'Fault Codes',
  FIELD_MODIFICATIONS: 'Field Modifications',
  TROUBLESHOOTING: 'Troubleshooting',
  DIAGNOSTIC: 'Diagnostic',
  HISTORY: 'Service History',
  MY_SESSIONS: 'My Sessions',
  SESSIONS_ADMIN: 'Troubleshooting Session Admin',
  ERROR: 'Error'
} as const
